import ge, { useRef as F, useLayoutEffect as xe, useEffect as U, createElement as p, useReducer as _e, useState as ie, isValidElement as G, cloneElement as le } from "react";
import { clsx as k } from "../../clsx/dist/clsx.m.js";
import { render as Be } from "react-dom";
function B() {
  return B = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, B.apply(this, arguments);
}
function he(e, t) {
  if (e == null) return {};
  var n = {}, s = Object.keys(e), i, f;
  for (f = 0; f < s.length; f++)
    i = s[f], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Z(e) {
  return typeof e == "number" && !isNaN(e);
}
function $(e) {
  return typeof e == "boolean";
}
function Q(e) {
  return typeof e == "string";
}
function R(e) {
  return typeof e == "function";
}
function J(e) {
  return Q(e) || R(e) ? e : null;
}
function se(e) {
  return e === 0 || e;
}
function De(e, t) {
  return e === !1 || Z(e) && e > 0 ? e : t;
}
var pe = !!(typeof window < "u" && window.document && window.document.createElement);
function re(e) {
  return G(e) || Q(e) || R(e) || Z(e);
}
var Ce = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
}, A = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};
function Se(e, t, n) {
  n === void 0 && (n = 300);
  var s = e.scrollHeight, i = e.style;
  requestAnimationFrame(function() {
    i.minHeight = "initial", i.height = s + "px", i.transition = "all " + n + "ms", requestAnimationFrame(function() {
      i.height = "0", i.padding = "0", i.margin = "0", setTimeout(t, n);
    });
  });
}
function be(e) {
  var t = e.enter, n = e.exit, s = e.appendPosition, i = s === void 0 ? !1 : s, f = e.collapse, g = f === void 0 ? !0 : f, v = e.collapseDuration, a = v === void 0 ? 300 : v;
  return function(m) {
    var I = m.children, T = m.position, y = m.preventExitTransition, L = m.done, h = m.nodeRef, O = m.isIn, l = i ? t + "--" + T : t, c = i ? n + "--" + T : n, b = F(), E = F(
      0
      /* Enter */
    );
    xe(function() {
      o();
    }, []), U(function() {
      O || (y ? x() : D());
    }, [O]);
    function o() {
      var r = h.current;
      b.current = r.className, r.className += " " + l, r.addEventListener("animationend", P), r.addEventListener("animationcancel", P);
    }
    function P(r) {
      if (r.target === h.current) {
        var d = h.current;
        d.dispatchEvent(new Event(
          "d"
          /* ENTRANCE_ANIMATION_END */
        )), d.removeEventListener("animationend", P), d.removeEventListener("animationcancel", P), E.current === 0 && (d.className = b.current);
      }
    }
    function D() {
      E.current = 1;
      var r = h.current;
      r.className += " " + c, r.addEventListener("animationend", x);
    }
    function x() {
      var r = h.current;
      r.removeEventListener("animationend", x), g ? Se(r, L, a) : L();
    }
    return ge.createElement(ge.Fragment, null, I);
  };
}
var w = {
  list: /* @__PURE__ */ new Map(),
  emitQueue: /* @__PURE__ */ new Map(),
  on: function(t, n) {
    return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(n), this;
  },
  off: function(t, n) {
    if (n) {
      var s = this.list.get(t).filter(function(i) {
        return i !== n;
      });
      return this.list.set(t, s), this;
    }
    return this.list.delete(t), this;
  },
  cancelEmit: function(t) {
    var n = this.emitQueue.get(t);
    return n && (n.forEach(clearTimeout), this.emitQueue.delete(t)), this;
  },
  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function(t) {
    for (var n = this, s = arguments.length, i = new Array(s > 1 ? s - 1 : 0), f = 1; f < s; f++)
      i[f - 1] = arguments[f];
    this.list.has(t) && this.list.get(t).forEach(function(g) {
      var v = setTimeout(function() {
        g.apply(void 0, i);
      }, 0);
      n.emitQueue.has(t) || n.emitQueue.set(t, []), n.emitQueue.get(t).push(v);
    });
  }
}, we = ["delay", "staleId"];
function Me(e) {
  var t = _e(function(l) {
    return l + 1;
  }, 0), n = t[1], s = ie([]), i = s[0], f = s[1], g = F(null), v = F(/* @__PURE__ */ new Map()).current, a = function(c) {
    return i.indexOf(c) !== -1;
  }, u = F({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: e,
    containerId: null,
    isToastActive: a,
    getToast: function(c) {
      return v.get(c);
    }
  }).current;
  U(function() {
    return u.containerId = e.containerId, w.cancelEmit(
      3
      /* WillUnmount */
    ).on(
      0,
      L
    ).on(
      1,
      function(l) {
        return g.current && I(l);
      }
    ).on(
      5,
      m
    ).emit(
      2,
      u
    ), function() {
      return w.emit(
        3,
        u
      );
    };
  }, []), U(function() {
    u.isToastActive = a, u.displayedToast = i.length, w.emit(
      4,
      i.length,
      e.containerId
    );
  }, [i]), U(function() {
    u.props = e;
  });
  function m(l) {
    var c = l.containerId, b = u.props.limit;
    b && (!c || u.containerId === c) && (u.count -= u.queue.length, u.queue = []);
  }
  function I(l) {
    f(function(c) {
      return se(l) ? c.filter(function(b) {
        return b !== l;
      }) : [];
    });
  }
  function T() {
    var l = u.queue.shift(), c = l.toastContent, b = l.toastProps, E = l.staleId;
    h(c, b, E);
  }
  function y(l) {
    return !g.current || u.props.enableMultiContainer && l.containerId !== u.props.containerId || v.has(l.toastId) && l.updateId == null;
  }
  function L(l, c) {
    var b = c.delay, E = c.staleId, o = he(c, we);
    if (!(!re(l) || y(o))) {
      var P = o.toastId, D = o.updateId, x = o.data, r = u.props, d = function() {
        return I(P);
      }, N = D == null;
      N && u.count++;
      var _ = {
        toastId: P,
        updateId: D,
        isLoading: o.isLoading,
        theme: o.theme || r.theme,
        icon: o.icon != null ? o.icon : r.icon,
        isIn: !1,
        key: o.key || u.toastKey++,
        type: o.type,
        closeToast: d,
        closeButton: o.closeButton,
        rtl: r.rtl,
        position: o.position || r.position,
        transition: o.transition || r.transition,
        className: J(o.className || r.toastClassName),
        bodyClassName: J(o.bodyClassName || r.bodyClassName),
        style: o.style || r.toastStyle,
        bodyStyle: o.bodyStyle || r.bodyStyle,
        onClick: o.onClick || r.onClick,
        pauseOnHover: $(o.pauseOnHover) ? o.pauseOnHover : r.pauseOnHover,
        pauseOnFocusLoss: $(o.pauseOnFocusLoss) ? o.pauseOnFocusLoss : r.pauseOnFocusLoss,
        draggable: $(o.draggable) ? o.draggable : r.draggable,
        draggablePercent: o.draggablePercent || r.draggablePercent,
        draggableDirection: o.draggableDirection || r.draggableDirection,
        closeOnClick: $(o.closeOnClick) ? o.closeOnClick : r.closeOnClick,
        progressClassName: J(o.progressClassName || r.progressClassName),
        progressStyle: o.progressStyle || r.progressStyle,
        autoClose: o.isLoading ? !1 : De(o.autoClose, r.autoClose),
        hideProgressBar: $(o.hideProgressBar) ? o.hideProgressBar : r.hideProgressBar,
        progress: o.progress,
        role: o.role || r.role,
        deleteToast: function() {
          v.delete(P);
          var z = u.queue.length;
          if (u.count = se(P) ? u.count - 1 : u.count - u.displayedToast, u.count < 0 && (u.count = 0), z > 0) {
            var S = se(P) ? 1 : u.props.limit;
            if (z === 1 || S === 1)
              u.displayedToast++, T();
            else {
              var j = S > z ? z : S;
              u.displayedToast = j;
              for (var Y = 0; Y < j; Y++)
                T();
            }
          } else
            n();
        }
      };
      R(o.onOpen) && (_.onOpen = o.onOpen), R(o.onClose) && (_.onClose = o.onClose), _.closeButton = r.closeButton, o.closeButton === !1 || re(o.closeButton) ? _.closeButton = o.closeButton : o.closeButton === !0 && (_.closeButton = re(r.closeButton) ? r.closeButton : !0);
      var M = l;
      G(l) && !Q(l.type) ? M = le(l, {
        closeToast: d,
        toastProps: _,
        data: x
      }) : R(l) && (M = l({
        closeToast: d,
        toastProps: _,
        data: x
      })), r.limit && r.limit > 0 && u.count > r.limit && N ? u.queue.push({
        toastContent: M,
        toastProps: _,
        staleId: E
      }) : Z(b) && b > 0 ? setTimeout(function() {
        h(M, _, E);
      }, b) : h(M, _, E);
    }
  }
  function h(l, c, b) {
    var E = c.toastId;
    b && v.delete(b), v.set(E, {
      content: l,
      props: c
    }), f(function(o) {
      return [].concat(o, [E]).filter(function(P) {
        return P !== b;
      });
    });
  }
  function O(l) {
    var c = /* @__PURE__ */ new Map(), b = Array.from(v.values());
    return e.newestOnTop && b.reverse(), b.forEach(function(E) {
      var o = E.props.position;
      c.has(o) || c.set(o, []), c.get(o).push(E);
    }), Array.from(c, function(E) {
      return l(E[0], E[1]);
    });
  }
  return {
    getToastToRender: O,
    containerRef: g,
    isToastActive: a
  };
}
function me(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function Te(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function Ae(e) {
  var t = ie(!1), n = t[0], s = t[1], i = ie(!1), f = i[0], g = i[1], v = F(null), a = F({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: !0,
    canDrag: !1,
    boundingRect: null,
    didMove: !1
  }).current, u = F(e), m = e.autoClose, I = e.pauseOnHover, T = e.closeToast, y = e.onClick, L = e.closeOnClick;
  U(function() {
    u.current = e;
  }), U(function() {
    return v.current && v.current.addEventListener(
      "d",
      l,
      {
        once: !0
      }
    ), R(e.onOpen) && e.onOpen(G(e.children) && e.children.props), function() {
      var d = u.current;
      R(d.onClose) && d.onClose(G(d.children) && d.children.props);
    };
  }, []), U(function() {
    return e.pauseOnFocusLoss && b(), function() {
      e.pauseOnFocusLoss && E();
    };
  }, [e.pauseOnFocusLoss]);
  function h(d) {
    if (e.draggable) {
      o();
      var N = v.current;
      a.canCloseOnClick = !0, a.canDrag = !0, a.boundingRect = N.getBoundingClientRect(), N.style.transition = "", a.x = me(d.nativeEvent), a.y = Te(d.nativeEvent), e.draggableDirection === "x" ? (a.start = a.x, a.removalDistance = N.offsetWidth * (e.draggablePercent / 100)) : (a.start = a.y, a.removalDistance = N.offsetHeight * (e.draggablePercent === 80 ? e.draggablePercent * 1.5 : e.draggablePercent / 100));
    }
  }
  function O() {
    if (a.boundingRect) {
      var d = a.boundingRect, N = d.top, _ = d.bottom, M = d.left, H = d.right;
      e.pauseOnHover && a.x >= M && a.x <= H && a.y >= N && a.y <= _ ? c() : l();
    }
  }
  function l() {
    s(!0);
  }
  function c() {
    s(!1);
  }
  function b() {
    document.hasFocus() || c(), window.addEventListener("focus", l), window.addEventListener("blur", c);
  }
  function E() {
    window.removeEventListener("focus", l), window.removeEventListener("blur", c);
  }
  function o() {
    a.didMove = !1, document.addEventListener("mousemove", D), document.addEventListener("mouseup", x), document.addEventListener("touchmove", D), document.addEventListener("touchend", x);
  }
  function P() {
    document.removeEventListener("mousemove", D), document.removeEventListener("mouseup", x), document.removeEventListener("touchmove", D), document.removeEventListener("touchend", x);
  }
  function D(d) {
    var N = v.current;
    a.canDrag && N && (a.didMove = !0, n && c(), a.x = me(d), a.y = Te(d), e.draggableDirection === "x" ? a.delta = a.x - a.start : a.delta = a.y - a.start, a.start !== a.x && (a.canCloseOnClick = !1), N.style.transform = "translate" + e.draggableDirection + "(" + a.delta + "px)", N.style.opacity = "" + (1 - Math.abs(a.delta / a.removalDistance)));
  }
  function x() {
    P();
    var d = v.current;
    if (a.canDrag && a.didMove && d) {
      if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
        g(!0), e.closeToast();
        return;
      }
      d.style.transition = "transform 0.2s, opacity 0.2s", d.style.transform = "translate" + e.draggableDirection + "(0)", d.style.opacity = "1";
    }
  }
  var r = {
    onMouseDown: h,
    onTouchStart: h,
    onMouseUp: O,
    onTouchEnd: O
  };
  return m && I && (r.onMouseEnter = c, r.onMouseLeave = l), L && (r.onClick = function(d) {
    y && y(d), a.canCloseOnClick && T();
  }), {
    playToast: l,
    pauseToast: c,
    isRunning: n,
    preventExitTransition: f,
    toastRef: v,
    eventHandlers: r
  };
}
function Ee(e) {
  var t = e.closeToast, n = e.theme, s = e.ariaLabel, i = s === void 0 ? "close" : s;
  return p("button", {
    className: "Toastify__close-button Toastify__close-button--" + n,
    type: "button",
    onClick: function(g) {
      g.stopPropagation(), t(g);
    },
    "aria-label": i
  }, p("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, p("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}
function Ie(e) {
  var t, n, s = e.delay, i = e.isRunning, f = e.closeToast, g = e.type, v = e.hide, a = e.className, u = e.style, m = e.controlledProgress, I = e.progress, T = e.rtl, y = e.isIn, L = e.theme, h = B({}, u, {
    animationDuration: s + "ms",
    animationPlayState: i ? "running" : "paused",
    opacity: v ? 0 : 1
  });
  m && (h.transform = "scaleX(" + I + ")");
  var O = k("Toastify__progress-bar", m ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + L, "Toastify__progress-bar--" + g, (t = {}, t["Toastify__progress-bar--rtl"] = T, t)), l = R(a) ? a({
    rtl: T,
    type: g,
    defaultClassName: O
  }) : k(O, a), c = (n = {}, n[m && I >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = m && I < 1 ? null : function() {
    y && f();
  }, n);
  return p("div", Object.assign({
    role: "progressbar",
    "aria-hidden": v ? "true" : "false",
    "aria-label": "notification timer",
    className: l,
    style: h
  }, c));
}
Ie.defaultProps = {
  type: A.DEFAULT,
  hide: !1
};
var ke = ["theme", "type"], ee = function(t) {
  var n = t.theme, s = t.type, i = he(t, ke);
  return p("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: n === "colored" ? "currentColor" : "var(--toastify-icon-color-" + s + ")"
  }, i));
};
function Fe(e) {
  return p(ee, Object.assign({}, e), p("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}
function He(e) {
  return p(ee, Object.assign({}, e), p("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}
function ze(e) {
  return p(ee, Object.assign({}, e), p("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}
function je(e) {
  return p(ee, Object.assign({}, e), p("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}
function qe() {
  return p("div", {
    className: "Toastify__spinner"
  });
}
var ye = {
  info: He,
  warning: Fe,
  success: ze,
  error: je,
  spinner: qe
}, Ue = function(t) {
  var n, s, i = Ae(t), f = i.isRunning, g = i.preventExitTransition, v = i.toastRef, a = i.eventHandlers, u = t.closeButton, m = t.children, I = t.autoClose, T = t.onClick, y = t.type, L = t.hideProgressBar, h = t.closeToast, O = t.transition, l = t.position, c = t.className, b = t.style, E = t.bodyClassName, o = t.bodyStyle, P = t.progressClassName, D = t.progressStyle, x = t.updateId, r = t.role, d = t.progress, N = t.rtl, _ = t.toastId, M = t.deleteToast, H = t.isIn, z = t.isLoading, S = t.icon, j = t.theme, Y = k("Toastify__toast", "Toastify__toast-theme--" + j, "Toastify__toast--" + y, (n = {}, n["Toastify__toast--rtl"] = N, n)), Pe = R(c) ? c({
    rtl: N,
    position: l,
    type: y,
    defaultClassName: Y
  }) : k(Y, c), ae = !!d, fe = ye[y], oe = {
    theme: j,
    type: y
  }, q = fe && fe(oe);
  S === !1 ? q = void 0 : R(S) ? q = S(oe) : G(S) ? q = le(S, oe) : Q(S) ? q = S : z && (q = ye.spinner());
  function Re(X) {
    if (X) {
      var ve = {
        closeToast: h,
        type: y,
        theme: j
      };
      if (R(X)) return X(ve);
      if (G(X)) return le(X, ve);
    }
  }
  return p(O, {
    isIn: H,
    done: M,
    position: l,
    preventExitTransition: g,
    nodeRef: v
  }, p("div", Object.assign({
    id: _,
    onClick: T,
    className: Pe
  }, a, {
    style: b,
    ref: v
  }), p("div", Object.assign({}, H && {
    role: r
  }, {
    className: R(E) ? E({
      type: y
    }) : k("Toastify__toast-body", E),
    style: o
  }), q && p("div", {
    className: k("Toastify__toast-icon", (s = {}, s["Toastify--animate-icon Toastify__zoom-enter"] = !z, s))
  }, q), p("div", null, m)), Re(u), (I || ae) && p(Ie, Object.assign({}, x && !ae ? {
    key: "pb-" + x
  } : {}, {
    rtl: N,
    theme: j,
    delay: I,
    isRunning: f,
    isIn: H,
    closeToast: h,
    hide: L,
    type: y,
    style: D,
    className: P,
    controlledProgress: ae,
    progress: d
  }))));
}, Qe = /* @__PURE__ */ be({
  enter: "Toastify--animate Toastify__bounce-enter",
  exit: "Toastify--animate Toastify__bounce-exit",
  appendPosition: !0
}), Ve = /* @__PURE__ */ be({
  enter: "Toastify--animate Toastify__slide-enter",
  exit: "Toastify--animate Toastify__slide-exit",
  appendPosition: !0
}), Oe = function(t) {
  var n = Me(t), s = n.getToastToRender, i = n.containerRef, f = n.isToastActive, g = t.className, v = t.style, a = t.rtl, u = t.containerId;
  function m(I) {
    var T, y = k("Toastify__toast-container", "Toastify__toast-container--" + I, (T = {}, T["Toastify__toast-container--rtl"] = a, T));
    return R(g) ? g({
      position: I,
      rtl: a,
      defaultClassName: y
    }) : k(y, J(g));
  }
  return p("div", {
    ref: i,
    className: "Toastify",
    id: u
  }, s(function(I, T) {
    var y = T.length ? B({}, v) : B({}, v, {
      pointerEvents: "none"
    });
    return p("div", {
      className: m(I),
      style: y,
      key: "container-" + I
    }, T.map(function(L) {
      var h = L.content, O = L.props;
      return p(Ue, Object.assign({}, O, {
        isIn: f(O.toastId),
        key: "toast-" + O.key,
        closeButton: O.closeButton === !0 ? Ee : O.closeButton
      }), h);
    }));
  }));
};
Oe.defaultProps = {
  position: Ce.TOP_RIGHT,
  transition: Qe,
  rtl: !1,
  autoClose: 5e3,
  hideProgressBar: !1,
  closeButton: Ee,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  newestOnTop: !1,
  draggable: !0,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var W = /* @__PURE__ */ new Map(), ue, K, Ne, ce = [], de = !1;
function We(e, t) {
  var n = t.containerId, s = W.get(n || ue);
  return s ? s.getToast(e) : null;
}
function Le() {
  return Math.random().toString(36).substring(2, 9);
}
function Ge(e) {
  return e && (Q(e.toastId) || Z(e.toastId)) ? e.toastId : Le();
}
function V(e, t) {
  return W.size > 0 ? w.emit(
    0,
    e,
    t
  ) : (ce.push({
    content: e,
    options: t
  }), de && pe && (de = !1, K = document.createElement("div"), document.body.appendChild(K), Be(p(Oe, Object.assign({}, Ne)), K))), t.toastId;
}
function te(e, t) {
  return B({}, t, {
    type: t && t.type || e,
    toastId: Ge(t)
  });
}
function ne(e) {
  return function(t, n) {
    return V(t, te(e, n));
  };
}
function C(e, t) {
  return V(e, te(A.DEFAULT, t));
}
C.loading = function(e, t) {
  return V(e, te(A.DEFAULT, B({
    isLoading: !0,
    autoClose: !1,
    closeOnClick: !1,
    closeButton: !1,
    draggable: !1
  }, t)));
};
function Ye(e, t, n) {
  var s = t.pending, i = t.error, f = t.success, g;
  s && (g = Q(s) ? C.loading(s, n) : C.loading(s.render, B({}, n, s)));
  var v = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  }, a = function(I, T, y) {
    if (T == null) {
      C.dismiss(g);
      return;
    }
    var L = B({
      type: I
    }, v, n, {
      data: y
    }), h = Q(T) ? {
      render: T
    } : T;
    return g ? C.update(g, B({}, L, h)) : C(h.render, B({}, L, h)), y;
  }, u = R(e) ? e() : e;
  return u.then(function(m) {
    return a("success", f, m);
  }).catch(function(m) {
    return a("error", i, m);
  }), u;
}
C.promise = Ye;
C.success = /* @__PURE__ */ ne(A.SUCCESS);
C.info = /* @__PURE__ */ ne(A.INFO);
C.error = /* @__PURE__ */ ne(A.ERROR);
C.warning = /* @__PURE__ */ ne(A.WARNING);
C.warn = C.warning;
C.dark = function(e, t) {
  return V(e, te(A.DEFAULT, B({
    theme: "dark"
  }, t)));
};
C.dismiss = function(e) {
  return w.emit(
    1,
    e
  );
};
C.clearWaitingQueue = function(e) {
  return e === void 0 && (e = {}), w.emit(
    5,
    e
  );
};
C.isActive = function(e) {
  var t = !1;
  return W.forEach(function(n) {
    n.isToastActive && n.isToastActive(e) && (t = !0);
  }), t;
};
C.update = function(e, t) {
  t === void 0 && (t = {}), setTimeout(function() {
    var n = We(e, t);
    if (n) {
      var s = n.props, i = n.content, f = B({}, s, t, {
        toastId: t.toastId || e,
        updateId: Le()
      });
      f.toastId !== e && (f.staleId = e);
      var g = f.render || i;
      delete f.render, V(g, f);
    }
  }, 0);
};
C.done = function(e) {
  C.update(e, {
    progress: 1
  });
};
C.onChange = function(e) {
  return R(e) && w.on(
    4,
    e
  ), function() {
    R(e) && w.off(
      4,
      e
    );
  };
};
C.configure = function(e) {
  e === void 0 && (e = {}), de = !0, Ne = e;
};
C.POSITION = Ce;
C.TYPE = A;
w.on(
  2,
  function(e) {
    ue = e.containerId || e, W.set(ue, e), ce.forEach(function(t) {
      w.emit(
        0,
        t.content,
        t.options
      );
    }), ce = [];
  }
).on(
  3,
  function(e) {
    W.delete(e.containerId || e), W.size === 0 && w.off(
      0
      /* Show */
    ).off(
      1
      /* Clear */
    ).off(
      5
      /* ClearWaitingQueue */
    ), pe && K && document.body.removeChild(K);
  }
);
export {
  Qe as Bounce,
  ye as Icons,
  Ve as Slide,
  Oe as ToastContainer,
  Se as collapseToast,
  be as cssTransition,
  C as toast,
  Ae as useToast,
  Me as useToastContainer
};
//# sourceMappingURL=react-toastify.esm.js.map
